import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { RegistrationCard } from "@/components/RegistrationCard";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function MyRegistrations() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [comps, setComps] = useState({});
  const [catNames, setCatNames] = useState({});
  const [schedules, setSchedules] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/my-registrations")
      .then(async (r) => {
        setItems(r.data);
        const uniqueIds = [...new Set(r.data.map((x) => x.competition_id))];
        const compMap = {};
        const nameMap = {};
        const schedMap = {};
        await Promise.all(
          uniqueIds.map(async (cid) => {
            try {
              const info = await axios.get(`${BACKEND}/api/public/competitions/${cid}/info`);
              compMap[cid] = info.data.competition;
              (info.data.categories || []).forEach((c) => {
                nameMap[c.id] = c.nome;
              });
              const start = info.data.competition?.horario_inicio || "18:00";
              const sched = await axios.get(`${BACKEND}/api/public/schedule`, {
                params: { competition_id: cid, start_time: start },
              });
              schedMap[cid] = {};
              (sched.data.schedule || []).forEach((s) => {
                if (!s.category_id) return;
                const t = s.fase === "previa" ? `Prévia ${s.inicio}` : s.fase === "final" ? `Final ${s.inicio}` : s.inicio;
                schedMap[cid][s.categoria] = schedMap[cid][s.categoria] ? `${schedMap[cid][s.categoria]} · ${t}` : t;
              });
            } catch {
              compMap[cid] = compMap[cid] || null;
            }
          })
        );
        setComps(compMap);
        setCatNames(nameMap);
        setSchedules(schedMap);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="mb-6">
        <div className="overline mb-2">Área do Atleta</div>
        <h1 className="font-display text-5xl font-black tracking-tight">MINHAS INSCRIÇÕES</h1>
        <div className="text-sm text-[var(--text-secondary)] mt-1">
          Olá, <b>{user?.name}</b>. Acompanhe abaixo o status das suas inscrições.
        </div>
      </div>

      {loading ? (
        <div className="text-[var(--text-secondary)]">Carregando...</div>
      ) : items.length === 0 ? (
        <div className="card p-8 text-center text-[var(--text-secondary)]">Você ainda não possui inscrições.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map((r) => (
            <RegistrationCard
              key={r.id}
              r={r}
              comp={comps[r.competition_id]}
              catNames={catNames}
              schedule={schedules[r.competition_id]}
            />
          ))}
        </div>
      )}
    </div>
  );
}
